import React, { useEffect, useState, useContext } from 'react';
import { putEndpoint } from '../../api/api';
import { MEASURES_INSERT_URL, SCORECARDS_URL } from '../../api/urls';
import { useParams, useLocation } from 'react-router-dom';
import { get } from '../../utils/get';
import { Measure } from './Measure';
import { toast } from 'react-toastify';
import Axios from 'axios';
import { AuthContext } from '../../context/AuthContext';
import { useEvidence } from '../../context/EvidenceContext';
import { useTracking } from '../../context/TrackingContext';

interface KpiData {
    kpi_id: string;
    scorecard_id: string;
    notes: string;
    kpi_name: string;
    objective_name: string;
    objective_id: string;
    weight: number;
    target: number;
    kpi_target_type: string;
    kpi_type: string;
    score_type: string;
}

export const MeasuresContent = ({ perspectiveId, scorecard_id }) => {
  const [updatedTarget, setUpdatedTarget] = useState('');
  const [kpiData, setKpiData] = useState<KpiData[]>([]);
  const params = useParams();
  const location = useLocation();
  const scorecardId = get(params, 'scorecard_id') || scorecard_id;
//   let { data } = GetHook(`${SCORECARDS_URL}/${scorecardId}/kpi?perspective_id=${perspectiveId}`);
  const [measureResponse, putMeasures] = putEndpoint();
  const accessToken = localStorage.getItem("access_token");
  const savedtrackingId  = useTracking();

  const auth = useContext(AuthContext);
  const { user } = get(auth, "authState");

  const { evidenceType, evidenceData } = useEvidence();

  useEffect(() => {
    if (
        get(measureResponse, 'data') &&
        !get(measureResponse, 'error') &&
        !get(measureResponse, 'pending')
    ) {
        toast.success('Your measures have been sent for approval!');
        const { id } = measureResponse?.data?.returned_resultset[0];
        setUpdatedTarget(id);
    } else if (
        get(measureResponse, 'error') &&
        !get(measureResponse, 'pending')
    ) {
        toast.error('Failed to update');
    }
  }, [measureResponse]);

  useEffect(() => {
    const fetchKpiData = async () => {
      try {
        const response = await Axios.get(`${SCORECARDS_URL}/${scorecardId}/kpi`, {
          params: {
            perspective_id: perspectiveId
          },
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        });
        setKpiData(response.data.data || []);
      } catch (error) {
        toast.error('Failed to fetch KPIs');
      }
    };

    fetchKpiData();
  }, [perspectiveId, scorecardId, accessToken]);

  const handleSubmit = async (kpiId, values) => {
    try {
        const valuesToUpdate = {
            actual_value: parseFloat(get(values, 'actualValue', '').replace(/,/g, '')),
            period: get(values, 'kpiTargets.label', ''),
            evidence_type: evidenceType || null,
            evidence_data: evidenceData || null
        };

        const supervisorName = 
            user?.is_manager
                ? get(user, "organisation.parent_organisation.manager.names")
                : get(user, "organisation.manager.names");

        const supervisorId = user?.is_manager
        ? get(user, "organisation.parent_organisation.manager.manager_id")
        : get(user, "organisation.manager.id");

        const owner_id = get(user, "id");
        const owner_name = get(user, "names");

        const trackingId = savedtrackingId.trackingId;
        console.log('Tracking ID: ', trackingId);

        let adaUrl: string | null = null;

        if (valuesToUpdate.evidence_type === 'ada') {
            adaUrl = `http://adaweb/ada.web/OpenQuery.aspx?SERVER_ID=ADALIB&APP=1&LIB=4&QYNUM=15&QUERYPARAMS='F_FILENO=${valuesToUpdate.evidence_data?.ada_ref};F_FOLIONO=${valuesToUpdate.evidence_data?.folio_no};`;
        }

        await Axios.post(MEASURES_INSERT_URL, {
            status: "pending-approval",
            scorecard_id: scorecardId,
            kpi_id: kpiId,
            actual_value: valuesToUpdate.actual_value,
            period: valuesToUpdate.period,
            evidence_type: valuesToUpdate.evidence_type,
            evidence_data: adaUrl ? { ada_url: adaUrl } : null,
            supervisor: supervisorName,
            owner_id: owner_id,
            owner_name: owner_name,
            parent_id: supervisorId,
            tracking_id: trackingId
        }, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });

        localStorage.setItem("apiValue", get(values, 'kpiTargets.value', ''));
        toast.success('Your measures have been sent for approval!');

    } catch (error) {
        toast.error(get(error, "response.data.message"));
    }
  };  

  return (
    <>
      {kpiData.map(kpi => {
          return (
              <Measure
                  key={kpi.kpi_id}
                  kpi={kpi}
                  handleSubmit={values => handleSubmit(kpi.kpi_id, values)}
                  reload={updatedTarget}
              />
          );
      })}
    </>
  );
};
